import { Box, Button, Skeleton, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { FC, useState } from "react";
import useResponsive from "../../hooks/useResponsive";
import { btnSty } from "../UIElements/styles-typography";
import { JobIdDetailsProps } from "../../interface/job_board";
import { getUrlPathId } from "../../utils/url-id";
import JobHeading from "./JobHeading";
import JobInfo from "./JobInfo";
import AllApplications from "./AllApplication";
import JobDetails from "./JobDetails";
import { useLocation } from "react-router-dom";

const JobBoardDetailsContent: FC<{
  jobDetails: JobIdDetailsProps;
  loading: boolean;
  modalStatus: string;
  setModalStatus: React.Dispatch<React.SetStateAction<string>>;
  onUpdated: () => void;
}> = ({ jobDetails, loading, modalStatus, setModalStatus, onUpdated }) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const location = useLocation();
  const [select, setSelect] = useState("job_details");

  return (
    <Stack sx={{ paddingX: 2, mt: 3 }}>
      <JobHeading
        jobDetails={jobDetails}
        loading={loading}
        jobId={getUrlPathId(location?.pathname)}
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
      />
      <JobInfo jobDetails={jobDetails} loading={loading} />

      {!loading ? (
        <Box
          sx={{
            margin: 2,
            padding: isMedium ? 3 : 4,
            borderRadius: "3px",
            minHeight: "25vh",
            backgroundColor: theme.palette.common.white,
          }}
        >
          <Box display={"flex"}>
            <Stack
              direction={"row"}
              sx={{
                gap: 1,
                background: "#284CB133",
                p: 1,
                borderRadius: "12px",
                my: 2,
              }}
            >
              <Button
                sx={{
                  ...btnSty,
                  color: select === "job_details" ? "#fff" : "#1E1E1E",
                  background:
                    select === "job_details" ? theme.palette.primary.main : "",
                }}
                onClick={() => setSelect("job_details")}
              >
                Job Details
              </Button>
              <Button
                sx={{
                  ...btnSty,
                  color: select === "all_applicants" ? "#fff" : "#1E1E1E",
                  background:
                    select === "all_applicants"
                      ? theme.palette.primary.main
                      : "",
                }}
                onClick={() => setSelect("all_applicants")}
              >
                All Applicants
              </Button>
            </Stack>
          </Box>

          {select === "job_details" && (
            <JobDetails
              jobDetails={jobDetails}
              jobId={getUrlPathId(location?.pathname) ?? ""}
              onUpdated={onUpdated}
            />
          )}
          {select === "all_applicants" && <AllApplications />}
        </Box>
      ) : (
        <Skeleton variant="rounded" width={"98%"} height={500} sx={{ mx: 3 }} />
      )}
    </Stack>
  );
};

export default JobBoardDetailsContent;
